// src/admin/pages/AdminUsers.js
import React, { useState, useEffect, useContext } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import {
    FaSearch,
    FaSort,
    FaSortUp,
    FaSortDown,
    FaTrash,
    FaUserShield,
    FaUserSlash,
    FaEye,
    FaPlus,
    FaKey 
} from "react-icons/fa";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import {
  getAdminUsers,
  deleteAdminUser,
  toggleAdminUserStatus,
  createAdminUser,
} from "../../services/adminUsers.api";
import {
  getStaffPermissions,
  updateStaffPermissions,
} from "../../services/adminStaffPermissions.api";


function AdminUsers() {
    const [isOpen, setIsOpen] = useState(false);
    const { lang } = useContext(AdminLanguageContext);

    const adminRole = React.useMemo(() => {
  try {
    const token = localStorage.getItem("adminToken");
    if (!token) return null;

    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.role; // "admin" | "staff"
  } catch {
    return null;
  }
}, []);

    const [permUser, setPermUser] = useState(null);

const [permissions, setPermissions] = useState({
  can_manage_products: false,
  can_manage_orders: false,
  can_manage_customers: false,
  can_manage_messages: false,
  can_manage_marketing: false,
  can_manage_banners: false,
  can_manage_shipping: false,
  can_view_analytics: false,
  can_manage_seo: false,
  can_manage_staff: false,
});



const openPermissions = async (user) => {
  setPermUser(user);
  const data = await getStaffPermissions(user.id);

  setPermissions({
  can_manage_products: !!data?.can_manage_products,
  can_manage_orders: !!data?.can_manage_orders,
  can_manage_customers: !!data?.can_manage_customers,
  can_manage_messages: !!data?.can_manage_messages,
  can_manage_marketing: !!data?.can_manage_marketing,
  can_manage_banners: !!data?.can_manage_banners,
  can_manage_shipping: !!data?.can_manage_shipping,
  can_view_analytics: !!data?.can_view_analytics,
  can_manage_seo: !!data?.can_manage_seo,
  can_manage_staff: !!data?.can_manage_staff,
});
};


    const TEXT = {
        EN: {
            title: "Users",
            search: "Search by name or email...",
            allRoles: "All roles",
            admin: "Admin",
            staff: "Staff",
            customer: "Customer",
            allStatuses: "All statuses",
            active: "Active",
            suspended: "Suspended",
            name: "Name",
            email: "Email",
            role: "Role",
            status: "Status",
            created: "Created",
            actions: "Actions",
            loading: "Loading users...",
            empty: "No users found.",
            view: "View",
            toggle: "Toggle",
            delete: "Delete",
            deleteTitle: "Delete User?",
            deleteText: "Are you sure? This action cannot be undone.",
            cancel: "Cancel",
            prev: "Prev",
            next: "Next",
            joined: "Joined:",
            addUser: "Add User",
            username: "Username",
            password: "Password",
            emailOptional: "Email (optional)",
            create: "Create",
            creating: "Creating...",
            permissions: "Permissions",
            save: "Save",
        },
        AR: {
            title: "المستخدمون",
            search: "ابحث بالاسم أو البريد الإلكتروني...",
            allRoles: "جميع الأدوار",
            admin: "مدير",
            staff: "موظف",
            customer: "عميل",
            allStatuses: "جميع الحالات",
            active: "نشط",
            suspended: "موقوف",
            name: "الاسم",
            email: "البريد الإلكتروني",
            role: "الدور",
            status: "الحالة",
            created: "تاريخ الإنشاء",
            actions: "الإجراءات",
            loading: "جارٍ تحميل المستخدمين...",
            empty: "لا يوجد مستخدمون.",
            view: "عرض",
            toggle: "تغيير الحالة",
            delete: "حذف",
            deleteTitle: "حذف المستخدم؟",
            deleteText: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء.",
            cancel: "إلغاء",
            prev: "السابق",
            next: "التالي",
            joined: "تاريخ الانضمام:",
            addUser: "إضافة مستخدم",
            username: "اسم المستخدم",
            password: "كلمة المرور",
            emailOptional: "البريد الإلكتروني (اختياري)",
            create: "إنشاء",
            creating: "جارٍ الإنشاء...",
            permissions: "الصلاحيات",
            save: "حفظ",
        },
    }[lang];

    const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");
const perms = JSON.parse(localStorage.getItem("staffPermissions") || {});
const isAdmin = adminUser.role === "admin";

const canAccess = isAdmin || perms.can_manage_staff;


    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState("");
    const [roleFilter, setRoleFilter] = useState("All");
    const [statusFilter, setStatusFilter] = useState("All");
    const [loading, setLoading] = useState(true);

    const [sortBy, setSortBy] = useState(null);
    const [sortDirection, setSortDirection] = useState("asc");

    const [page, setPage] = useState(1);
    const perPage = 8;

    const [deleteId, setDeleteId] = useState(null);
    const [showAdd, setShowAdd] = useState(false);
const [creating, setCreating] = useState(false);

const [newUser, setNewUser] = useState({
  username: "",
  email: "",
  password: "",
  role: "staff",
  is_active: true,
});


    useEffect(() => {
  if (!canAccess) {
  setLoading(false);
  setUsers([]);
  return;
}


  setLoading(true);

  getAdminUsers()
    .then((data) => setUsers(data))
    .catch(console.error)
    .finally(() => setLoading(false));
}, [adminRole]);


   const filtered = users.filter((u) => {
  const q = search.toLowerCase();

  return (
    (
      u.name.toLowerCase().includes(q) ||
      (u.email && u.email.toLowerCase().includes(q))
    ) &&
    (roleFilter === "All" || u.role === roleFilter) &&
    (statusFilter === "All" || u.status === statusFilter)
  );
});


    const sorted = [...filtered].sort((a, b) => {
        if (!sortBy) return 0;
        let vA = a[sortBy];
        let vB = b[sortBy];

        if (sortBy === "createdAt") {
            vA = new Date(vA);
            vB = new Date(vB);
        } else {
            vA = String(vA).toLowerCase();
            vB = String(vB).toLowerCase();
        }

        return sortDirection === "asc" ? (vA > vB ? 1 : -1) : (vA < vB ? 1 : -1);
    });

    const totalPages = Math.ceil(sorted.length / perPage);
    const currentPage = Math.min(page, totalPages || 1);
    const paginated = sorted.slice((currentPage - 1) * perPage, currentPage * perPage);

    const toggleStatus = async (id) => {
  await toggleAdminUserStatus(id);

  setUsers((prev) =>
    prev.map((u) =>
      u.id === id
        ? { ...u, status: u.status === "active" ? "suspended" : "active" }
        : u
    )
  );
};


    const confirmDelete = async () => {
  await deleteAdminUser(deleteId);
  setUsers((prev) => prev.filter((u) => u.id !== deleteId));
  setDeleteId(null);
};

    const submitNewUser = async () => {
  if (!newUser.username.trim()) {
    alert(lang === "EN" ? "Username is required" : "اسم المستخدم مطلوب");
    return;
  }
  if (!newUser.password.trim()) {
    alert(lang === "EN" ? "Password is required" : "كلمة المرور مطلوبة");
    return;
  }

  try {
    setCreating(true);

    const created = await createAdminUser({
      username: newUser.username.trim(),
      email: newUser.email.trim() || null,
      password: newUser.password,
      role: newUser.role,
      is_active: newUser.is_active ? 1 : 0,
    });

    setUsers((prev) => [created, ...prev]);

    setShowAdd(false);
    setNewUser({
      username: "",
      email: "",
      password: "",
      role: "staff",
      is_active: true,
    });
  } catch (e) {
    alert(e.message);
  } finally {
    setCreating(false);
  }
};

    const getSortIcon = (field) => {
        if (sortBy !== field) return <FaSort className="inline ml-1 opacity-40" />;
        return sortDirection === "asc" ? <FaSortUp className="inline ml-1" /> : <FaSortDown className="inline ml-1" />;
    };

const PERMISSION_LABELS = {
  can_manage_products:
    lang === "AR" ? "إدارة المنتجات والتصنيفات والمخزون" : "Manage Products, Categories & Inventory",

  can_manage_orders:
    lang === "AR" ? "إدارة الطلبات والسلال المتروكة" : "Manage Orders & Abandoned Carts",

  can_manage_customers:
    lang === "AR" ? "إدارة العملاء" : "Manage Customers",

  can_manage_messages:
    lang === "AR" ? "إدارة الرسائل" : "Manage Messages",

  can_manage_marketing:
    lang === "AR" ? "إدارة التسويق وأكواد الخصم" : "Manage Marketing & Promo Codes",

  can_manage_banners:
    lang === "AR" ? "إدارة البنرات (Top / Sale)" : "Manage Banners (Top / Sale)",

  can_manage_shipping:
    lang === "AR" ? "إدارة الشحن" : "Manage Shipping",

  can_view_analytics:
    lang === "AR" ? "عرض التحليلات ونشاط المستخدمين" : "View Analytics & User Activity",

  can_manage_seo:
    lang === "AR" ? "إدارة SEO" : "Manage SEO",

  can_manage_staff:
    lang === "AR" ? "إدارة المستخدمين والموظفين" : "Manage Users & Staff",
};



    return (
        <div className={`flex bg-gray-100 min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
            <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

            <div className="flex-1 lg:ml-64 transition-all duration-300">
                <AdminHeader setIsOpen={setIsOpen} />

                <main className="p-4 sm:p-6 animate-fadeSlide">
               {!canAccess && (
  <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
    <p className="text-red-700 font-semibold">
      {lang === "EN"
        ? "You are not allowed to manage users and staff."
        : "غير مصرح لك بإدارة المستخدمين والموظفين"}
    </p>
  </div>
)}

          {canAccess && (
            <>
                    <div className="flex items-center justify-between mb-6">
  <h1 className="text-3xl font-bold text-cyan-700">{TEXT.title}</h1>

  <button
    onClick={() => setShowAdd(true)}
    className="
      px-4 py-2 bg-cyan-600 text-white
      rounded-xl shadow hover:bg-cyan-700 transition
      flex items-center gap-2 font-semibold
    "
  >
    <FaPlus />
    {TEXT.addUser}
  </button>
</div>


                    {/* SEARCH + FILTERS */}
                    <div className="flex flex-wrap gap-4 mb-6">
                        <div className="relative flex-1 min-w-[220px]">
                            <FaSearch className="absolute left-3 top-3 text-gray-400" />
                            <input
                                type="text"
                                placeholder={TEXT.search}
                                className="w-full pl-10 p-3 border rounded-xl shadow-sm"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setPage(1);
                                }}
                            />
                        </div>

                        <select className="p-3 rounded-xl border shadow-sm" value={roleFilter} onChange={(e) => setRoleFilter(e.target.value)}>
                            <option value="All">{TEXT.allRoles}</option>
                            <option value="admin">{TEXT.admin}</option>
                            <option value="staff">{TEXT.staff}</option>
                            <option value="customer">{TEXT.customer}</option>
                        </select>

                        <select className="p-3 rounded-xl border shadow-sm" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                            <option value="All">{TEXT.allStatuses}</option>
                            <option value="active">{TEXT.active}</option>
                            <option value="suspended">{TEXT.suspended}</option>
                        </select>
                    </div>

                    <div className="hidden md:block bg-white rounded-xl shadow overflow-hidden">
  {loading ? (
    <div className="p-6 text-center">{TEXT.loading}</div>
  ) : paginated.length === 0 ? (
    <div className="p-6 text-center">{TEXT.empty}</div>
  ) : (
    <table className="w-full">
      <thead className="bg-gray-200 text-gray-700">
  <tr>
    <th className="p-3">{TEXT.username}</th>
    <th className="p-3">{TEXT.email}</th>
    <th className="p-3">{TEXT.role}</th>
    <th className="p-3">{TEXT.status}</th>
    <th className="p-3">{TEXT.created}</th>
    <th className="p-3 text-center">{TEXT.actions}</th>
  </tr>
</thead>

      <tbody>
        {paginated.map((u) => (
          <tr key={u.id} className="border-b hover:bg-gray-50">
            <td className="p-3 font-medium">{u.name}</td>

<td className="p-3 text-sm text-gray-600">
  {u.email || "—"}
</td>

<td className="p-3 capitalize">{u.role}</td>


            <td className="p-3">
              <span
                className={`px-3 py-1 rounded-full text-xs font-semibold ${
                  u.status === "active"
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {u.status}
              </span>
            </td>

            <td className="p-3 text-sm text-gray-500">
              {new Date(u.createdAt).toLocaleDateString()}
            </td>

            <td className="p-3 flex justify-center gap-4">
              <button
                onClick={() => toggleStatus(u.id)}
                className="text-orange-600"
                title={TEXT.toggle}
              >
                {u.status === "active" ? <FaUserSlash /> : <FaUserShield />}
              </button>

              <button
                onClick={() => setDeleteId(u.id)}
                className="text-red-600"
                title={TEXT.delete}
              >
                <FaTrash />
              </button>
              {u.role === "staff" && canAccess && (
  <button
    onClick={() => openPermissions(u)}
    className="text-cyan-600"
    title="Permissions"
  >
    <FaKey />
  </button>
)}

            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )}
</div>

<div className="md:hidden space-y-4">
  {paginated.map((u) => (
    <div key={u.id} className="bg-white rounded-xl shadow p-4">
      <div className="font-bold text-cyan-700">{u.name}</div>
{u.email && (
  <div className="text-xs text-gray-500 mt-0.5">{u.email}</div>
)}

      <div className="text-sm text-gray-500 capitalize">{u.role}</div>

      <span
        className={`inline-block mt-2 px-3 py-1 rounded-full text-xs font-semibold ${
          u.status === "active"
            ? "bg-green-100 text-green-700"
            : "bg-red-100 text-red-700"
        }`}
      >
        {u.status}
      </span>

      <div className="flex justify-end gap-4 mt-3">
  {(isAdmin || perms.can_manage_staff) && (
    <>
      <button onClick={() => toggleStatus(u.id)} className="text-orange-600">
        <FaUserShield />
      </button>

      <button onClick={() => setDeleteId(u.id)} className="text-red-600">
        <FaTrash />
      </button>
    </>
  )}
</div>
    </div>
  ))}
</div>
</>
)}
                   {/* ADD USER MODAL */}
{showAdd && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-40">
    <div className="bg-white p-6 rounded-2xl shadow-xl w-96 animate-fadeSlide">
      <h2 className="text-lg font-bold text-cyan-700 mb-4">
        {TEXT.addUser}
      </h2>

      <div className="space-y-3">
        <div>
          <label className="text-sm font-semibold text-gray-600 block mb-1">
            {TEXT.username}
          </label>
          <input
            className="w-full p-3 border rounded-xl shadow-sm"
            value={newUser.username}
            onChange={(e) =>
              setNewUser({ ...newUser, username: e.target.value })
            }
          />
        </div>

        <div>
          <label className="text-sm font-semibold text-gray-600 block mb-1">
            {TEXT.email}
          </label>
          <input
            className="w-full p-3 border rounded-xl shadow-sm"
            placeholder={TEXT.emailOptional}
            value={newUser.email}
            onChange={(e) =>
              setNewUser({ ...newUser, email: e.target.value })
            }
          />
        </div>

        <div>
          <label className="text-sm font-semibold text-gray-600 block mb-1">
            {TEXT.password}
          </label>
          <input
            type="password"
            className="w-full p-3 border rounded-xl shadow-sm"
            value={newUser.password}
            onChange={(e) =>
              setNewUser({ ...newUser, password: e.target.value })
            }
          />
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-sm font-semibold text-gray-600 block mb-1">
              {TEXT.role}
            </label>
            <select
              className="w-full p-3 border rounded-xl shadow-sm"
              value={newUser.role}
              onChange={(e) =>
                setNewUser({ ...newUser, role: e.target.value })
              }
            >
              <option value="admin">{TEXT.admin}</option>
              <option value="staff">{TEXT.staff}</option>
            </select>
          </div>

          <div className="flex items-end">
            <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
              <input
                type="checkbox"
                checked={newUser.is_active}
                onChange={(e) =>
                  setNewUser({ ...newUser, is_active: e.target.checked })
                }
              />
              {lang === "EN" ? "Active" : "نشط"}
            </label>
          </div>
        </div>
      </div>

      <div className="flex justify-end gap-3 mt-6">
        <button
          className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
          onClick={() => setShowAdd(false)}
          disabled={creating}
        >
          {TEXT.cancel}
        </button>

        <button
          className="px-4 py-2 rounded-lg bg-cyan-600 text-white hover:bg-cyan-700"
          onClick={submitNewUser}
          disabled={creating}
        >
          {creating ? TEXT.creating : TEXT.create}
        </button>
      </div>
    </div>
  </div>
)}

                    {/* DELETE MODAL */}
                    {deleteId !== null && (
                        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-40">
                            <div className="bg-white p-6 rounded-xl shadow-xl w-80 animate-fadeSlide">
                                <h2 className="text-lg font-bold mb-3 text-red-600">{TEXT.deleteTitle}</h2>
                                <p className="text-gray-700 mb-6">{TEXT.deleteText}</p>

                                <div className="flex justify-end gap-3">
                                    <button className="px-4 py-2 rounded-lg bg-gray-300 hover:bg-gray-400" onClick={() => setDeleteId(null)}>
                                        {TEXT.cancel}
                                    </button>
                                    <button className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600" onClick={confirmDelete}>
                                        {TEXT.delete}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </main>
                {permUser && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-xl w-96">
      <h2 className="text-lg font-bold mb-4">
        {TEXT.permissions} – {permUser.name}
      </h2>

      {Object.keys(permissions).map((key) => (
        <label key={key} className="flex items-center gap-2 mb-2">
          <input
            type="checkbox"
            checked={permissions[key]}
            onChange={(e) =>
              setPermissions({ ...permissions, [key]: e.target.checked })
            }
          />
          {PERMISSION_LABELS[key]}
        </label>
      ))}

      <div className="flex justify-end gap-2 mt-4">
        <button onClick={() => setPermUser(null)}>{TEXT.cancel}</button>
        <button
          className="bg-cyan-600 text-white px-4 py-2 rounded"
          onClick={async () => {
            await updateStaffPermissions(permUser.id, permissions);

// 🔥 if admin updated HIMSELF (rare but possible)
const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");

if (adminUser.id === permUser.id) {
  localStorage.setItem("staffPermissions", JSON.stringify(permissions));
}

setPermUser(null);
          }}
        >
          {TEXT.save}
        </button>
      </div>
    </div>
  </div>
)}

            </div>
        </div>
    );
}

export default AdminUsers;
